<template>
  <div>
    <search-header :form="searchForm" :formInline="formInline" @on-event="searchEvent"></search-header>
    <Table border :loading="loading" :columns="columns" :data="data" :max-height="max_height"></Table>
    <Page
      class-name="page"
      :total="total"
      size="small"
      show-sizer
      show-total
      show-elevator
      @on-change="changePage"
      @on-page-size-change="changeSize"
    />
  </div>
</template>
<script>
import SearchHeader from "../../components/SearchHeader";
import YnModal from "../../components/YnModal";
import { getPageCustomerList } from "./../../http/laboratory";
import { dictDataList, provinceList, nextList } from "./../../http/commom";
export default {
  components: { SearchHeader, YnModal },
  data() {
    return {
      loading:true,
      editModel:false,
      editId:'',
      editFrom:{},
      delModel:false,
      delId:'',
      addModel: false, //添加模态框
      addFrom: {},
      max_height: 0,
      total: 0,
      size: 10,
      current: 1,
      api_type: [], //接口协议
      data_type: [], //客户类型
      data_lab_type: [], //客户对接类型
      province: [], //省份列表
      city: [],
      area: [],
      searchLabName:"",
      key:"",
      provinceId:"",
      cityId:"",
      searchForm: [
        {
          fromType: "Input",
          type: "text",
          place: "实验室名称",
          value: "name"
        },
        { fromType: "Button", type: "primary", place: "搜索", event: "search" },
        { fromType: "Button", type: "primary", place: "重置", event: "reset" },
      ],
      formInline: {},
      columns: [
        {
          title: "实验室名称",
          align:"center",
          key: "name",
          minWidth:150,
          ellipsis:true,
          tooltip:true
        },
        {
          title: "接口地址",
          key: "apiAddress",
           align:"center",
           minWidth:200,
          ellipsis:true,
          tooltip:true
        },
        {
          title: "接口协议",
          key: "apiType",
           align:"center",
           minWidth:100,
          ellipsis:true,
          tooltip:true
        },
        {
          title: "省",
          key: "province",
           align:"center",
           minWidth:80,
          ellipsis:true,
          tooltip:true
        },
        {
          title: "市",
          key: "city",
           align:"center",
           minWidth:80,
          ellipsis:true,
          tooltip:true
        },
        {
          title: "区/县",
          key: "area",
           align:"center",
           minWidth:80,
          ellipsis:true,
          tooltip:true
        },
        {
          title: "联系人",
          key: "contact",
           align:"center",
           minWidth:80,
          ellipsis:true,
          tooltip:true
        },
        {
          title: "联系电话",
          key: "contactPhone",
           align:"center",
           minWidth:150,
          ellipsis:true,
          tooltip:true
        },
        {
          title: "接入时间",
          key: "createTime",
           align:"center",
           minWidth:150,
          ellipsis:true,
          tooltip:true
        },
        {
          title: "操作",
          key: "action",
          fixed:"right",
          width: 200,
          align: "center",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px"
                  },
                  on: {
                    click: () => {
                       this.$router.push({path:'/LaboratoryMap',query:{id:params.row.id,enabled:params.row.enabled}});
                    }
                  }
                },
                "项目映射"
              ),
              h(
                "Button",
                {
                  props: {
                    type: "error",
                    size: "small"
                  },
                  on: {
                    click: () => {
                        this.$router.push({path:'/LaboratoryM',query:{id:params.row.id,enabled:params.row.enabled}});
                    }
                  }
                },
                "标本跟踪"
              )
            ]);
          }
        }
      ],
      data: []
    };
  },
  mounted() {
    this.max_height = this.$getBrowerHeight();
    window.onresize = () => {
      this.max_height = this.$getBrowerHeight();
    };
    this.init();
  },
  methods: {
    //基础数据获取
    init() {
      provinceList().then(res => {
        this.province = res;
      });
      dictDataList().then(res => {
        this.api_type = res.filter(item => item.t === "data_api_type")[0].list;
        this.data_type = res.filter(item => item.t === "data_type")[0].list;
        this.data_lab_type = res.filter(
          item => item.t === "data_lab_type"
        )[0].list;
        this.getList();
      });
       //获取缓存值
         this.key= localStorage.getItem("data-center-token");
    },
    //获取列表
    getList() {
      getPageCustomerList({
        current: this.current,
        hospitalName: this.searchLabName,
        size: this.size,
        token: this.key
      }).then(res => {
        if(res){
              res.records.forEach(item => {
              //时间处理
              item.createTime = this.$formatDate(item.createTime, "01", "03");
              //接口协议处理
              this.api_type.map(api => {
                if (item.apiType == api.code) {
                  item.apiType = api.name;
                }
              });
              //省处理
              this.province.map(api => {
                if (item.province == api.id) {
                  item.province = api.name;
                  this.provinceId=api.id;
                  nextList(
                  {regionCode:this.provinceId}
                  ).then(res =>{
                    this.city=res;
                    //市处理
                    this.city.map(api => {
                      if (item.city == api.id) {
                        item.city = api.name;
                        this.cityId=api.id
                        nextList({
                          regionCode:this.cityId
                        }).then(res=>{
                            this.area=res;
                            //区处理
                            this.area.map(api =>{
                              if(item.area == api.id)
                              item.area = api.name;
                            })
                        })
                      }
                    });
                  });
                }
              });
            });
            this.data = res.records;
            this.total = res.total;
            this.loading = false;
          }
      });
    },
    //搜索组件按钮
    searchEvent(obj) {
      this[obj.type](obj);
    },
    reset() {
      this.formInline = {};
      this.searchLabName = "";
      this.getList();
    },
    search(obj) {
      this.loading = true;
      this.searchLabName = obj.name;
      this.getList();
    },
    //改变页码
    changePage(page) {
      this.loading = true;
      this.current = page;
      this.getList();
    },
    //改变每页显示条数
    changeSize(size) {
      this.loading = true;
      this.size = 10;
      this.getList();
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/views/laboratory/laboratory.vue